<div class="page-container">
  <section>
    <div class="nav-bar">
      <div class="nav-bar-container">
        <div class="action">
          <a [routerLink]="localeService.getLink(routesEnum.LEXICON)" class="link" aria-label="Go to blog list">
            <img src="assets/img/arrow-small-right.svg" height="24" width="24" alt="">
            Alle Beiträge
          </a>
        </div>
        <ul class="nav-list">
          <li *ngFor="let anchor of (postData$ | async)?.anchors" class="nav-item">
            <a class="link"
               [routerLink]="'.'"
               [fragment]="anchor?.href"
               (click)="scrollTo(anchor?.href)"
            >
              {{ anchor?.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="body">
      <article>
        <div class="article-head">
          <div class="article-data">
            <span class="badge"
                  [style.backgroundColor]="(postData$ | async)?.category?.background_text"
                  [style.color]="(postData$ | async)?.category?.color_text"
            >
               {{(postData$ | async)?.category?.name}}
            </span>
            <span class="date">
                {{(postData$ | async)?.createdDate | date: 'dd.MM.yyy' }}
            </span>
          </div>

          <h1 class="article-title">
            {{(postData$ | async)?.title}}
          </h1>

          <app-social-list></app-social-list>
        </div>
        <div *ngIf="!!(postData$ | async)?.post_preview" class="article-img">
          <img [src]="(postData$ | async)?.post_preview" alt="">
        </div>

        <div class="article-body">
          <div [innerHTML]="getPostMarking((postData$ | async)?.lexicon_description)"></div>
        </div>
        <div class="article-footer">
          <div class="author-data">
            <div class="img-container">
              <img [src]="(postData$ | async)?.author?.author_avatar" alt="">
            </div>
            <div class="info-container">
              <p class="additional-info">Written by</p>
              <p class="name">
                <a [routerLink]="localeService.getLink(routesEnum.AUTHOR_PAGE) + '/' + (postData$ | async)?.author?.author_url" class="link">
                  {{(postData$ | async)?.author?.full_name}}
                </a>
              </p>
              <p class="position">{{(postData$ | async)?.author?.positions}}</p>
            </div>
          </div>
          <app-social-list></app-social-list>
        </div>
      </article>
    </div>
  </section>
</div>
